import { render, staticRenderFns } from "./ProjectDetailsDocumentList.vue?vue&type=template&id=ea26408e&scoped=true&"
import script from "./ProjectDetailsDocumentList.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsDocumentList.vue?vue&type=style&index=0&id=ea26408e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea26408e",
  null
  
)

export default component.exports